var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content",style:({
      position: _vm.isAbsolute ? 'absolute' : '',
    })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_text"},[_c('p',[_vm._v(" Copyright © 1998-2023 Joyful and carefree All Rights Reserved.. "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/recordQuery"}},[_vm._v(" 闽ICP备2023012112号-1")]),_vm._v(" | 开发者：福州乐无忧信息技术有限公司 ")]),_c('p',[_vm._v("微博：@TCG HOME | 微信公众号：TCGHOME | 版本号： 1.0")])])
}]

export { render, staticRenderFns }